const tpKeyIndicator = {
  dc: 'DC',
  assessMonth: '考核月份',
  assessMonthStart: '开始月份',
  assessMonthEnd: '结束月份',
  carrierCode: '承运商代码',
  serviceProvider: '服务商',
  statType: '统计类型',
  onTimeDeliveryRate: '准时交货率',
  podTimelyRate: '回单及时率',
  rejectionRate: '拒收率',
  createTime: '创建时间',
  msg: {}
};
export default tpKeyIndicator;



// WEBPACK FOOTER //
// ./src/page/assess/tpKeyIndicator/lang/tpKeyIndicator.zh.js